import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { PlantService } from '../proxy/general/controllers';
import {
  PlantCreateDto,
  PlantDto,
  PlantExcelDownloadDto,
  PlantUpdateDto,
} from '../proxy/general/dtos/plant';
import { PLANT_CONFIG, PLANT_FIELDS } from './plant.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-plant',
  host: {
    'data-component-scope': 'general-plant',
  },
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PlantService, ConfirmationService],
  templateUrl: './plant.html',
  styleUrl: './plant.scss',
})
export class Plant extends BaseHierarchicalCrudComponent<
  PlantDto,
  PlantCreateDto,
  PlantUpdateDto,
  PlantExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PlantService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Plant', ids),
  };
  config = PLANT_CONFIG;
  fields = PLANT_FIELDS;

  protected prepareUpdateDto(data: any, selected: PlantDto): PlantUpdateDto {
    return {
      consumableId: data.consumableId ?? selected.consumableId,
      geneticMaterialId: data.geneticMaterialId ?? selected.geneticMaterialId,
      plantTypeId: data.plantTypeId ?? selected.plantTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Plant';
  }
}
